<script setup>
import { computed, onUnmounted, ref } from 'vue';

const props = defineProps({
  /** '' → #anchor на текущей странице; '/' → /#anchor на главной */
  anchorBase: {
    type: String,
    default: '',
  },
  logoHref: {
    type: String,
    default: '/',
  },
  lkUrl: {
    type: String,
    default: '/lk',
  },
  createUrl: {
    type: String,
    default: '/new',
  },
  createLabel: {
    type: String,
    default: 'Создать работу',
  },
  aboutUrl: {
    type: String,
    default: '/about',
  },
});

const menuItems = computed(() => {
  const base = props.anchorBase;
  const href = (anchor) => `${base}#${anchor}`;

  return [
    { href: href('how-work'), label: 'Как это работает?' },
    { href: href('advantage'), label: 'Преимущества' },
    { href: href('review'), label: 'Отзывы' },
    { href: href('tariffs'), label: 'Тарифы' },
    { href: props.aboutUrl, label: 'О компании' },
  ];
});

const mobileMenuOpen = ref(false);

const setMobileMenuOpen = (open) => {
  mobileMenuOpen.value = open;
  document.body.classList.toggle('active', open);
};

const toggleMobileMenu = () => {
  setMobileMenuOpen(!mobileMenuOpen.value);
};

const closeMobileMenu = () => {
  setMobileMenuOpen(false);
};

onUnmounted(() => {
  document.body.classList.remove('active');
});
</script>

<template>
  <div class="header1">
    <div class="header1__center">
      <div class="header1__content">
        <a :href="logoHref" class="header1__logo">
          <img src="/img/logo.svg" alt="Examka" />
          <img src="/img/logo2.svg" alt="" />
        </a>
        <ul class="header1__menu">
          <li v-for="item in menuItems" :key="item.href" class="header1__menu-item">
            <a :href="item.href">{{ item.label }}</a>
          </li>
        </ul>
        <a :href="lkUrl" class="header1__lk"><i></i><span></span></a>
      </div>
    </div>
  </div>

  <div class="header-mobile1" :class="{ active: mobileMenuOpen }">
    <div class="header-mobile1__content">
      <a :href="logoHref" class="header-mobile1__logo">
        <img src="/img/logo.svg" alt="Examka" />
      </a>
      <div class="header-mobile1__menu" @click="toggleMobileMenu"><span></span></div>
    </div>
    <div class="header-mobile1__drop">
      <div class="header-mobile1__center">
        <ul class="header-mobile1__list">
          <li v-for="item in menuItems" :key="item.href" class="header-mobile1__list-item">
            <a :href="item.href" @click="closeMobileMenu">{{ item.label }}</a>
          </li>
        </ul>
      </div>
      <div class="header-mobile1__bottom">
        <a :href="lkUrl" class="style1" @click="closeMobileMenu"><span>Личный кабинет</span></a>
        <a :href="createUrl" class="style2" @click="closeMobileMenu">
          <span>{{ createLabel }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
